// @flow
import * as React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import './styles.scss'

function ArticleLink({
  publisherDomain,
  articlePath,
  title,
  lead
}: {
  publisherDomain: string,
  articlePath: string,
  title: string,
  lead: string
}) {
  return (
    <a
      href={`https://www.${publisherDomain}/${articlePath}`}
      target='_parent'
      className='item'
    >
      <i className='external icon top aligned' />
      <div className='content'>
        <div className='header'>{title}</div>
        {lead}
      </div>
    </a>
  )
}

export function ArticleList() {
  const publisherDomain = parseHostname().publicationDomain

  return (
    <aside
      className='ui segment article-list'
      style={{ backgroundColor: '#fff' }}
    >
      <h4 className='ui infographic tiny header'>
        Storys zu «Game of Thrones»:
      </h4>
      <div className='ui icon very infographic list'>
        <ArticleLink
          publisherDomain={publisherDomain}
          articlePath={
            'kultur/fernsehen/game-of-thrones-das-grosse-schlachten-beginnt/story/27654917'
          }
          lead={'Zehn Theorien zur letzten Staffel (ABO+)'}
        />
        <ArticleLink
          publisherDomain={publisherDomain}
          articlePath={'kultur/fernsehen/was-bisher-geschah/story/30102636'}
          lead={'Was bisher geschah (ABO+)'}
        />
      </div>
    </aside>
  )
}
